export default "__VITE_ASSET__DsUSEi9m__"